export default {
  无派送网点: {
    url: 'getWithoutInstoreSite',
    header: {
      乡镇: 'streetName',
      网点名称: 'siteName'
    }
  },
  派送品牌明细: {
    url: 'getCabCompanyDetail',
    header: {
      运营组: 'groupName',
      网点名称: 'cabinetName',
      打卡总数: 'totalNum',
      圆通: 'ytNum',
      中通: 'ztNum',
      申通: 'stNum',
      韵达: 'ydNum',
      极兔: 'jtNum',
      丰网: 'fwNum',
      顺丰: 'sfNum',
      邮政: 'yzNum',
      EMS: 'emsNum',
      德邦: 'dbNum',
      京东: 'jdNum',
      天猫: 'tmNum',
      百世: 'bsNum'
    }
  },
  出入库明细: {
    url: 'getCabExpressInOut',
    header: {
      省: 'provinceName',
      市: 'cityName',
      区: 'areaName',
      网点名称: 'cabinetName',
      负责人手机号: 'phone',
      日期: 'time',
      派送量: 'instoreNum',
      签收量: 'signNum'
    }
  }
}
